import { reqRoleMenu } from '@/api/user'
import { asyncRoutes } from '@/router/route'
import { displayTree } from '@/utils/treeUtil'
/**
 *
 *通过判断 meta.permissionKey 的值是否在auths中判断是否有权限
 * @param auths
 * @param route
 */
function hasPermission(auths, route) {
  if (route.meta && route.meta.permissionKey) {
    return auths.some((auth) => route.meta.permissionKey == auth.trim())
  } else {
    return true
  }
}

/**
 * 通过递归过滤异步路由表
 * @param routes asyncRoutes
 * @param auths
 */
export function filterAsyncRoutes(routes, auths) {
  const res = []

  routes.forEach((route) => {
    const tmp = { ...route }
    if (hasPermission(auths, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, auths)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  auths: [],
  routes: [],
  displayRoutes: [], //扁平化的routes
}

const mutations = {
  SET_AUTHS: (state, auths) => {
    state.auths = auths
  },
  SET_ROUTES: (state, routes) => {
    state.routes = routes
  },
  SET_DISPLAY_ROUTES: (state, routes) => {
    state.displayRoutes = routes
  },
}

const actions = {
  generateRoutes({ commit, state }, auths = []) {
    let accessedRoutes = state.routes || []
    return new Promise((resolve) => {
      accessedRoutes = filterAsyncRoutes(asyncRoutes, auths)

      let displayRoutes = []
      if (Array.isArray(accessedRoutes)) {
        accessedRoutes.map((item) => {
          let list = displayTree(item)
          displayRoutes = displayRoutes.concat(list)
        })
      }
      commit('SET_AUTHS', auths)
      commit('SET_ROUTES', accessedRoutes)
      commit('SET_DISPLAY_ROUTES', displayRoutes)
      resolve(accessedRoutes)
    })
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
